import { Route } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const RouteIcon = createLucideIcon(Route);
